import { Component, OnInit, ViewChild, enableProdMode } from '@angular/core';
import { DxDataGridComponent, DxScrollViewComponent } from 'devextreme-angular';
import { GeneralService } from '../../../services/formulacion/general.service';
import { UtilHelper } from '../../../_helpers/util';
import { environment } from '../../../../environments/environment';
declare const toastr: any;

@Component({
  selector: 'app-inicio-inicio',
  templateUrl: './inicio-inicio.component.html',
  styles: []
})
export class InicioInicioComponent implements OnInit {

  techos: any[];
  baseUrl = environment.apiEndpoint;
  rol: number = 0;
  constructor(private _gs: GeneralService) {
    this.getTechoByUO();
  }

  tipo_agregacion_id: number = 1;

  ngOnInit() {
  }

  getTechoByUO() {
    let u = JSON.parse(localStorage.getItem('u'));
    this.rol = u.rol;
   
    this._gs.getTechoByUOByTipoAgregacion(u.unidad, this.tipo_agregacion_id).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {          
          this.techos = result.data;
        } else {
          this.techos = [];
        }
      },
      (error) => { console.log('Error', error); });

  }

  onToolbarPreparing(e) {
    e.toolbarOptions.items.unshift({
      location: 'before',
    });
  }
}
